<template>
  <PopWidget :isShow="isShowPopWidget" :isFull="1" style="z-index:4">
    <template v-slot:title>
      <img class="l-t-title" 
        src="../../assets/yuebao/yuebao-detail-title.png" />
    </template>
    <template v-slot:content>
      <div class="main-content flex">
        <div class="menu-wrap">
          <div class="inner-back">
            <div class="menu-wrap-scroll">
              <div :key="menu.id" class="menu-btn" v-for="(menu,i) of menuItems"
                @click="menuClick(i)" :class="{select:menuSelectIndex==i}"
                 :data-id="menu.id">
                <div class="normal-bg"></div>
                <div class="select-bg"></div>
                <div class="menu-text">
                  {{ menu.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="m-w-page" ref="scrollWrapPage" @scroll="pageScroll">
          <div class="record-item flex" v-for='item of recordList'>
            <div>
              <div class="flex sy-icon-wrap">
                <div class="shouyi-icon">
                </div>
                <div>{{ item.type_name }}</div>
              </div>
              <div class="item-time-w">
                {{ item.created_at }}
              </div>
            </div>
            <div>
              <div class="amount-p">
                {{getSignChar(item)}}{{item.amount}}
              </div>
              <div class="amount-v">
                {{ item.t_yeb }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </PopWidget>
</template>

<script>
import PopWidget from '../common/PopWidget.vue'
import Request from '../../common/Request.js'
import { mapMutations } from 'vuex';

export default{
  props:{
    show:Number,
  },
  data(){
    return {
      isShowPopWidget:0,
      menuSelectIndex:0,
      menuItems:[
        {
          name:'全部',
          id:0,
          key:'',
        },
        {
          name:'收入',
          id:1,
          key:'interest',
        },
        {
          name:'转入',
          id:2,
          key:'interest_in',
        },
        {
          name:'转出',
          id:3,
          key:'interest_out',
        }
      ],
      currentPage:1,
      recordList:[],
      nextPageGetting:0,
    }
  }, 
  mounted(){
    this.menuInit();
  },
  methods:{
    ...mapMutations(['showLoading','closeLoading']),
    menuInit(){
      this.menuItems = [
        {
          name:this.$t('yebDetail.all'),
          id:0,
          key:'',
        },
        {
          name:this.$t('yebDetail.income'),
          id:1,
          key:'interest',
        },
        {
          name:this.$t('yebDetail.transferIn'),
          id:2,
          key:'interest_in',
        },
        {
          name:this.$t('yebDetail.transferOut'),
          id:3,
          key:'interest_out',
        }
      ];
    },
    pageScroll(e){
      let sTop = e.target.scrollTop;
      let scrollSpace = sTop + e.target.clientHeight
      let sub = e.target.scrollHeight - scrollSpace;
      if(sub < 5){
        this.getNextPageData();
      }
    },
    getNextPageData(){
      if(!this.recordPager)return;
      const {per_page,total} = this.recordPager;
      const totalPage = Math.ceil(total/per_page);
      if(this.currentPage >= totalPage) return;
      if(this.nextPageGetting == 0){
        this.nextPageGetting = 1;
        this.currentPage++;
        this.getRecordList(this.currentPage);
      }
    },
    getSignChar(item){
      if(['interest_in','interest'].includes(item.type)){
        return '+'
      }else{
        return '-'
      }
    },
    menuClick(i){
      this.menuSelectIndex = i;
      this.recordList = [];
      this.currentPage = 1;
      this.getRecordList();
    },
    getRecordList(page){
      /*type
      收入 interest
      转入 interest_in
      转出 interest_out
      */
      let cPage = page ? page : 1;
      let k = this.menuItems[this.menuSelectIndex].key;
      let query = `?page=${cPage}&type=${k}`;
      this.showLoading();
      Request.get('/yeb/record/'+query).then(res => {
        this.closeLoading();
        if(res.data.data && res.data.data.data){
          this.recordPager = res.data.data;
          this.recordPager.data.forEach(item => {
            this.recordList.push(item);
          })
        }
        this.nextPageGetting = 0;
      }).catch(() => {
        this.closeLoading();
        this.nextPageGetting = 0;
      });
    }
  },
  watch:{
    show(n){
      this.isShowPopWidget = n;
      this.recordList = [];
      this.currentPage = 1;
      this.getRecordList();
    }
  },
  components:{
    PopWidget
  }
}
</script>

<style scoped lang="stylus">
.main-content
  width 100%
  height auto
  .menu-wrap
    width 1.8rem
    height 2.28rem
    position relative
    z-index 1
    overflow auto
    &::-webkit-scrollbar
      width 0
    .inner-back
      width 1.23rem
      min-height 100%
      height auto
      background linear-gradient(#EACD9B, #D8A96B)
      box-shadow 0 0 10px 0 rgba(0,0,0,.6)
      padding-bottom .3rem
    .menu-wrap-scroll
      width 100%
      height auto
      padding-top .12rem
      .menu-btn
        width 1.25rem
        height .44rem
        display block
        margin 0 0 .06rem .05rem
        position relative
        &:active
          appearance none
          -moz-appearance none
          -webkit-appearance none
        .select-bg
          display none
        &.select
          .normal-bg
            display none
          .select-bg
            display block
        .normal-bg
          width 1.11rem
          height 100%
          background-image url(../../assets/geren/vip-menu-btn.png)
          background-repeat no-repeat
          background-size 100% 100%
        .select-bg
          width 100%
          height 100%
          background-image url(../../assets/geren/vip-menu-se-btn.png)
          background-repeat no-repeat
          background-size 100% 100%
        .menu-text
          width 1.11rem
          height 100%
          text-align center
          line-height .4rem
          font-weight bold
          font-size .14rem
          color #842404
          position absolute
          z-index 1
          top 0
          left 0
  .m-w-page
    width 4.68rem      
    height 2.28rem
    padding-top .14rem
    padding-bottom .14rem
    margin-left -.05rem
    background-image url(../../assets/geren/geren-back.png)
    background-repeat no-repeat
    background-size 100% 100%
    overflow auto
    .record-item
      width 92%
      height .6rem
      padding 0 .12rem
      font-size .12rem
      justify-content space-between
      align-items center
      margin .02rem auto .06rem auto
      border-radius .04rem
      border 1px solid #907A31
      background-color #E8D8A5
      .sy-icon-wrap
        margin-bottom .08rem
      .shouyi-icon
        width .24rem
        height .2rem
        margin-right .06rem
        background-image url(../../assets/yuebao/detail-shouyi-ico.png)
        background-size 100% 100%
      .item-time-w
        line-height 1
        background-color #E0B475
        color #FFF1C6
        border-radius .08rem
        padding .03rem .08rem
      .amount-p
        margin-bottom .12rem
        color #1E9C5C
      .amount-v
        color #AC712B
</style>